import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api, apiUrls } from "../utils/api";

export const fetchProjects = createAsyncThunk("getProjects", async (params, thunkAPI) => {
  let token = null;
  if (params) {
    if (params.token) {
      token = params.token;
      delete params['token'];
    }
    await thunkAPI.dispatch(projects.actions.updateState(params));
  }
  const state = Object.assign({}, thunkAPI.getState(), params);
  const { isListView, isArchived, value } = state.projects;
  const searchURl = apiUrls.GetAllOrSearchedProjects + `?searchText=${value}&includeArchived=${isArchived && isListView}`;
  const url = isListView ? searchURl : value ? searchURl : apiUrls.Projects;

  return api.get(url, null,  token).then((response) => response.json());
});

export const projects = createSlice({
  name: "projects",
  initialState: {
    value: "",
    isListView: !!localStorage.getItem("projectsListView"),
    isArchived: false,
    projects: [],
    loading: false,
    projectLoading: false,
  },
  reducers: {
    updateState: (state, action) => {
      const isList = action?.payload?.isListView;
      if (isList !== undefined) {
        localStorage.setItem("projectsListView", isList ? "1" : "");
      }
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProjects.pending, (state) => {
      state.projectLoading = true;
    });
    builder.addCase(fetchProjects.fulfilled, (state, action) => {
      state.projectLoading = false;
      state.loading = false;
      state.projects = action.payload;
    });
    builder.addCase(fetchProjects.rejected, (state) => {
      state.projectLoading = false;
      state.loading = false;
    });
  },
});

export const selectors = {
  getState: (state) => state.projects,
};
